import { render, staticRenderFns } from "./ShippingCompanyTableAdmin.vue?vue&type=template&id=ea7cf922&scoped=true"
import script from "./ShippingCompanyTableAdmin.vue?vue&type=script&lang=js"
export * from "./ShippingCompanyTableAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea7cf922",
  null
  
)

export default component.exports